import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetch_all, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';

import {
  Alert,
  Button,
  DialogActions,
  Grid
} from '@mui/material';

import {
  TagChip,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { Base } from './Base';

import { User } from '../../../models/User';
import { UserTag } from '../../../models/UserTag';
import { currentPracticeAtom } from '../../../lib/practice';

// const { DateTime } = require("luxon");

type Props = {
  open: boolean;
  setOpen: (b:boolean) => void;
  onClose?: () => void;
  refetch?: () => void;
  linkedUser?: number;
};

export const CoachMollieLinkCreate: FunctionComponent<Props> = ({refetch, open, setOpen, onClose, linkedUser}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [description, setDescription] = useState<string>("");
  const [fakeAmount, setFakeAmount] = useState<string>("0.0");
  const [amount, setAmount] = useState<number>(0.0);
  const [fakeExpiryDays, setFakeExpiryDays] = useState<string>("30");
  const [expiryDays, setExpiryDays] = useState<number>(30);

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["user", 'short', (login?.practice_id || currentPractice?.id), linkedUser],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          id: linkedUser,
          fields: [
            'id', 'first_name', 'last_name', 'consent_status'
          ],
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    enabled: !!(login?.practice_id || currentPractice?.id) && !!linkedUser,
  });






  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<UserTag>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      if (!!refetch) refetch();
      setOpen(false);
    },
  });








  
  useEffect(() => {
    setAmount(!!fakeAmount ? parseFloat(fakeAmount.replace(",", ".")) : 0.0)
  }, [fakeAmount]);
  useEffect(() => {
    setExpiryDays(!!fakeExpiryDays ? parseInt(fakeExpiryDays, 10) : 30)
  }, [fakeExpiryDays]);
  
  return (<>
    <Base
      name="mollie_link_create"
      title={t("coach.mollie_links.create_dialog")}
      onClose={() => {
        setDescription('');
        setAmount(0.0);
        if (!!onClose) onClose();
      }}
      content={<>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Alert severity='info'>
              <Typography>{t("coach.mollie_links.help_text_dialog")}</Typography>
            </Alert>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5">{t("coach.mollie_links.titles.basic_info")}</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextInput
              id="description"
              caption={t("coach.mollie_links.field.description")}
              starred
              value={description}
              onChange={(v) => {
                setDescription(v);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              id="amount"
              caption={t("coach.mollie_links.field.amount")}
              starred
              value={fakeAmount || ''}
              onChange={(v) => {
                setFakeAmount(v);
              }}
            />
          </Grid>
          {!!object && <Grid item xs={6}>
            <TextInput
              id="amount"
              caption={t("coach.mollie_links.field.linked_to")}
              disabled
              value={[object?.first_name, object?.last_name].join(" ")}
              onChange={(v) => {
                
              }}
            />
          </Grid>}
          <Grid item xs={12}>
            <Typography variant="h5">{t("coach.mollie_links.titles.advanced_options")}</Typography>
          </Grid>
          <Grid item xs={6}>
            <TextInput
              id="expiry_days"
              caption={t("coach.mollie_links.field.expiry_days")}
              starred
              value={fakeExpiryDays || ''}
              onChange={(v) => {
                setFakeExpiryDays(v);
              }}
            />
          </Grid>
        </Grid>
      </>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Button
          onClick={(e) => {
            setOpen(false);
          }}
          color="primary"
        >{t("coach.general.actions.cancel")}</Button>
        <Button
          disabled={!amount || (!!amount && amount < 0) || !description || !expiryDays}
          onClick={(e) => {
            mutationCustomAction.mutate({
              formData: {
                object: 'mollie_link',
                class_action: "custom_api_create_link",
                practice_id: (currentPractice?.id || login?.practice_id),
                description: description,
                amount: amount,
                expiry_days: expiryDays,
                ...(!!linkedUser ? {
                  linked_item_type: "User",
                  linked_item_id: linkedUser
                } : {})
              }
            });
          }}
          color="primary"
        >{t("client.general.actions.save")}</Button>
      </DialogActions>}
      open={open}
      setOpen={setOpen}
    />
  </>);
}
